import { IconExprEnum } from '@app/shared/interfaces/dropdown-option';

export type IListItemIcon = (item: any, iconExpr: IconExprEnum) => string;
export type ISetSelectBoxIcon = (
  item: {
    selectedItem: any;
    element: HTMLElement;
  },
  iconExpr: IconExprEnum
) => void;

export const listItemIcon: IListItemIcon = (item, iconExpr: IconExprEnum) => {
  const iconProps = {
    flag: () => {
      const iconPath = `assets/img/flag/${item?.country}.png`;
      return item?.country ? `<img class="flag-phone-icon" src="${iconPath}">` : '';
    },
  };
  return (iconProps[iconExpr] && iconProps[iconExpr]()) || '';
};

export const setSelectBoxIcon: ISetSelectBoxIcon = ({ selectedItem, element }, iconExpr: IconExprEnum) => {
  setTimeout(() => {
    const iconContainerClass = 'select-box-selected-item-icon';
    if (iconExpr && element && selectedItem) {
      const selectedBox = (element as HTMLElement).querySelector('.dx-texteditor-container');
      if (selectedBox) {
        const fieldInput = selectedBox.querySelector('.dx-texteditor-input');
        if (!fieldInput?.classList?.contains('selected-input-field')) {
          fieldInput.classList.add('selected-input-field');
        }
        document.querySelector(`.${iconContainerClass}`)?.remove();
        const iconContainer = document.createElement('div') as HTMLElement;
        iconContainer.classList.add(iconContainerClass);
        iconContainer.innerHTML = listItemIcon(selectedItem, iconExpr) as any;
        selectedBox.prepend(iconContainer);
      }
    }
    if (!selectedItem) {
      document.querySelector(`.${iconContainerClass}`)?.remove();
      document.querySelector('.selected-input-field')?.classList?.remove('.selected-input-field');
    }
  }, 0);
};
